import styled from "styled-components";

export const Container = styled.div`
  border: 1px solid #dce5ee;
  border-radius: 10px;
  padding: 16px;
  margin-top: 12px;
  background: #ffffff;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;
`;

export const Title = styled.h4`
  margin: 0;
  color: #1a1a1a;
  font-size: 16px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #525252;
`;

export const ToggleRow = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  cursor: pointer;
`;

export const Section = styled.div`
  margin-top: 16px;
  border: 1px solid #e6ecf1;
  border-radius: 8px;
  overflow: hidden;
`;

export const SectionToggle = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: none;
  background: #f7fafc;
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
`;

export const SectionContent = styled.div`
  padding: 14px;
  border-top: 1px solid #e6ecf1;
`;

export const SectionHint = styled.span`
  color: #707070;
  font-size: 12px;
  font-weight: 400;
`;

export const NativeSelect = styled.select`
  width: 100%;
  height: 48px;
  border: 1px solid #9d9e9d;
  border-radius: 4px;
  padding: 0 12px;
  font-size: 14px;
  color: #1a1a1a;
  background: #ffffff;
`;

export const HelperText = styled.span`
  color: #707070;
  font-size: 12px;
`;

export const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
`;

export const ActionButton = styled.button`
  border: 1px solid #d1dbe5;
  background: ${({ primary }) => (primary ? "#0073ab" : "#ffffff")};
  color: ${({ primary }) => (primary ? "#ffffff" : "#1a1a1a")};
  border-radius: 6px;
  padding: 8px 14px;
  cursor: pointer;
`;

export const OptionRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 8px;
  margin-bottom: 8px;
  align-items: center;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const AddOptionButton = styled.button`
  border: 1px dashed #0073ab;
  background: #f5fbff;
  color: #0073ab;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  margin-top: 8px;
`;
